import { render, staticRenderFns } from "./auditRecords.vue?vue&type=template&id=368e20d8&scoped=true&"
import script from "./auditRecords.vue?vue&type=script&lang=js&"
export * from "./auditRecords.vue?vue&type=script&lang=js&"
import style0 from "./auditRecords.vue?vue&type=style&index=0&id=368e20d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368e20d8",
  null
  
)

export default component.exports